<template>
  <div class="joinUs">
    <div class="topImg row">
      <div class="col-md-12">
        <img
          style="object-fit: cover;"
          :src="data.nav_pic"
          alt="南京小程序开发"
          title="南京小程序开发"
        />
        <div class="texts">
          <div>{{ data.nav_title }}</div>
          <div>{{ data.nav_desc }}</div>
        </div>
      </div>
    </div>
    <div class="recruit container">
      <div class="row">
        <div class="col-md-4 left">
          <img src="../assets/recruit.png" />
        </div>
        <div class="col-md-4">
          招贤纳士
        </div>
        <div class="col-md-4 right">
          <img src="../assets/recruit.png" />
        </div>
      </div>
      <p>
        墨客云科技锻炼机会多，扁平化管理，寻找有想法，有趣的你。Talk its
        cheaper,show your code。
      </p>
      <p>
        五险一金/弹性工作制/期权激励/轻松的工作环境.....更多内容，期待你的加入
      </p>
      <p>一个有趣的团队，期待有趣的你</p>
      <p>投递简历至 : hr@mokyun.com</p>
    </div>
    <div class="textData" v-for="(item, index) in employmentData">
      <div>{{ item.position }}</div>
      <div class="hr"></div>
      <p class="secondary">岗位职责：</p>
      <p v-for="(list, index) in item.duty">
        {{ list }}
      </p>
      <p class="secondary">任职要求：</p>
      <p v-for="(list, index) in item.requirement">
        {{ list }}
      </p>
    </div>
  </div>
</template>

<script>
import getData from '../api/getInfo';
export default {
  data() {
    return {
      employmentData: [],
      data: {},
    };
  },
  created() {
    this.getEmployment();
    this.separate();
  },
  mounted() {
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?75d1af96b450c5590fffaae8357a65e0';
      var s = document.getElementsByTagName('script')[0];
      // s.parentNode.insertBefore(hm, s)

      // var bp = document.createElement('script');
      var curProtocol = window.location.protocol.split(':')[0];
      if (curProtocol === 'https')
        hm.src = 'https://zz.bdstatic.com/linksubmit/push.js';
      else hm.src = 'http://push.zhanzhang.baidu.com/push.js';
      // var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    // 招聘信息
    getEmployment() {
      // getData
      //   .getEmployment()
      //   .then((res) => {
      //     console.log(res.data);
      let list = [
        {
          id: '1',
          position: 'Nodejs开发工程师',
          duty:
            '<p>1.负责平台服务端及相关产品和接口的研发及技术文档编写;<br />2.负责平台功能测试、线上系统维护;<br />3.实现平台用户交互的逻辑和优化;</p>',
          requirement:
            '<p data-v-cb1b6050="">1.精通javaScript和node.js;<br />2.有独立完成WEB项目和经验或能力;<br />3.精通MySQL,MongoDB等数据库,熟悉sql;<br />4.熟悉web前端js的交互(非前端框架);<br />5.熟悉Git操作;<br />6.两年以上工作经验;<br />7.具有良好的沟通能力,工作积极主动,责任心强,能承受一定的工作压力;</p>',
          appid: '23',
        },
        {
          id: '2',
          position: 'UI设计',
          duty:
            '<p data-v-cb1b6050="">1、配合部门领导在了解需求基础上，提出交互界面设计思路；</p>\n<p data-v-cb1b6050="">2、负责产品界面的交互设计、视觉设计（包含Web和移动APP）；</p>\n<p data-v-cb1b6050="">3、参与产品规划构思和创意过程，为开发工程师创建详细的界面说明文档，保证工程师的界面开发符合界面设计规范；</p>\n<p data-v-cb1b6050="">4、结合用户研究和产品分析的成果和业务需求充分发挥创意，设计UI界面，持续提高界面的用户体验；</p>\n<p data-v-cb1b6050="">5、. 将设计稿切图并配合研发人员实现产品最终效果。</p>',
          requirement:
            '<p data-v-cb1b6050="">1、大专及以上美术、设计、计算机相关专业毕业；</p>\n<p data-v-cb1b6050="">2、2年及以上界面设计类工作经验，熟悉设计工作流程，紧跟设计潮流、富有创新意识，可以独立把控整个设计过程；</p>\n<p data-v-cb1b6050="">3、精通Photoshop、Illustrator、Fireworks等绘图软件，熟悉Axure、Visio等交互设计软件；</p>\n<p data-v-cb1b6050="">4、具有专业的视觉设计能力和较全面的设计知识，能阐述具有说服力的设计理论；</p>\n<p data-v-cb1b6050="">5、有移动终端设计工作经验优先；</p>\n<p data-v-cb1b6050="">6、 喜欢并热爱设计工作，能独立完成设计工作，适应工作中的变化，并保持乐观精神；</p>\n<p data-v-cb1b6050="">7、 有较强的快速学习能力，积极主动，有责任心、耐心，沟通良好，有很好的团队合作精神，能根据项目的进度要求按时完成任务，具备一定的抗压能力。</p>',
          appid: '23',
        },
      ];
      let tempData = [];
      let tempObj = {};
      list.forEach((val, index) => {
        val.duty = val.duty.replace(/<\/?[^>]*>/g, '');
        val.requirement = val.requirement.replace(/<\/?[^>]*>/g, '');
        let title = val.duty.split('；');
        let texts = val.requirement.split('；');
        tempObj = {};
        tempObj.position = val.position;
        tempObj.duty = title;
        tempObj.requirement = texts;
        tempData.push(tempObj);
      });
      this.employmentData = tempData;
      // })
      // .catch((e) => {});
    },

    // 获取顶部图文信息
    separate() {
      // getData
      //   .separateImg()
      //   .then((res) => {
      let list = [
        {
          id: '1',
          nav_title: '解决方案',
          nav_pic: '1541475369769',
          nav_desc:
            '关注生活所关注的，了解商业所了解的，我们所做的一切，只是为了让科技改变生活。',
          sort: '6',
          appid: '23',
        },
        {
          id: '2',
          nav_title: '案例展示',
          nav_pic: '1541475386238',
          nav_desc:
            '根据行业现状按需定制，不做任何无用功，我们做的就是您想要的。',
          sort: '5',
          appid: '23',
        },
        {
          id: '6',
          nav_title: '功能',
          nav_pic: '1541488820596',
          nav_desc: '功能模块',
          sort: '4',
          appid: '23',
        },
        {
          id: '5',
          nav_title: '实验室',
          nav_pic: '1541475376231',
          nav_desc:
            '根据行业现状按需定制，不做任何无用功，我们做的就是您想要的。',
          sort: '3',
          appid: '23',
        },
        {
          id: '3',
          nav_title: '联系我们',
          nav_pic: '1541475595720',
          nav_desc:
            '去繁就简，留给你最好的体验，始终坚持契约精神，给我们一个机会，我们只会让你喜出望外。',
          sort: '2',
          appid: '23',
        },
        {
          id: '4',
          nav_title: '加入我们',
          nav_pic: '154147535974',
          nav_desc:
            '我们不仅仅是想做好研发，我们更想为这个蓬勃的互联网行业持续注入，开源精神，我们一直都在。',
          sort: '1',
          appid: '23',
        },
      ];
      list.forEach((v) => {
        if (v.nav_title == '加入我们') {
          this.data = v;
          this.data.nav_pic = `${getData.url}${v.nav_pic}`;
        }
      });
      // })
      // .catch((e) => {});
    },
  },
};
</script>

<style scoped>
.joinUs {
  width: 100%;
  background: #fafafa;
}
.row {
  margin: 0;
  padding: 0;
}
.topImg {
  width: 100%;
}
.topImg .col-md-12 {
  width: 100%;
  padding: 0;
  position: relative;
}
.topImg img {
  width: 100%;
  height: 100%;
}
.topImg .texts {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
.topImg .texts > div {
  width: 100%;
  text-align: center;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.topImg .texts > div:nth-child(1) {
  height: 60%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 8px;
  font-size: 50px;
  font-family: '黑体';
  font-weight: 600;
}
.topImg .texts > div:nth-child(2) {
  height: 40%;
  font-size: 15px;
  font-family: '黑体';
}
@media only screen and (min-width: 1100px) and (max-width: 1400px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 3rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 13px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1100px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 2rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 12px;
  }
}
@media only screen and (min-width: 768px) {
  .topImg {
    margin-top: 51px;
  }
}
@media only screen and (max-width: 768px) {
  .topImg .texts > div:nth-child(1) {
    font-size: 1.5rem;
  }
  .topImg .texts > div:nth-child(2) {
    font-size: 10px;
  }
  .topImg {
    margin-top: 53px;
  }
  .topImg .col-md-12 {
    height: 170px;
    object-fit: cover;
  }
}

.recruit {
  width: 50%;
  padding: 2em 1em 1.3em 1em;
  margin: 40px auto 0;
  box-shadow: 0px 7px 16px 0px rgba(116, 116, 116, 0.16);
  border: solid 1px #eeeeee;
  text-align: center;
}
.recruit > div {
  width: 100%;
  margin: 0 auto 1em;
  display: flex;
  justify-content: center;
  align-items: center;
}
.recruit > div .col-md-4 {
  font-size: 1.8em;
  width: 30%;
}
.recruit > div .left {
  /*background: red;*/
  text-align: right;
}
.recruit > div .right {
  /*background: red;*/
  text-align: left;
}
.recruit > div img {
  width: 30%;
  height: 100%;
}
.recruit p {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  /*line-height: 30px;*/
  letter-spacing: 0px;
  color: #444444;
}
.textData {
  width: 85%;
  /*height: 265px;*/
  box-shadow: 0px 8px 16px 0px rgba(217, 217, 217, 0.14);
  border: solid 1px #eeeeee;
  margin: 38px auto 20px;
  text-align: left;
  /*padding-left: 40px;*/
  padding: 0 2.6em 2.4em 2.6em;
}
.textData > div {
  margin-top: 43px;
  font-family: MicrosoftYaHei;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 0px;
  color: #343434;
}
.textData .hr {
  width: 12%;
  height: 1px;
  margin: 20px 0;
  background-color: #ccc;
}
.textData p {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 25px;
  letter-spacing: 0px;
  color: #666666;
}
.textData .secondary {
  margin: 20px 0;
  font-size: 16px;
}

@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .recruit {
    width: 65%;
  }
  .recruit > div {
    width: 100%;
    margin: 0 auto 1em;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .recruit > div .col-md-4 {
    width: 30%;
    font-size: 1.5em;
  }
  .recruit > div img {
    width: 40%;
    height: 100%;
  }
  .textData > div {
    margin-top: 35px;
    font-size: 22px;
    line-height: 15px;
  }
}

@media only screen and (max-width: 992px) {
  .recruit {
    width: 85%;
    padding-left: 1em;
    padding-right: 1em;
  }
  .recruit > div {
    width: 100%;
    margin: 0 auto 1em;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .recruit > div .col-md-4 {
    width: 30%;
    font-size: 1.2em;
  }
  .recruit > div img {
    width: 80%;
    height: 100%;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .textData > div {
    margin-top: 35px;
    font-size: 18px;
    line-height: 15px;
  }
  .textData .secondary {
    font-size: 15px;
  }
  .textData p {
    line-height: 20px;
  }
}
@media only screen and (max-width: 768px) and (min-width: 578px) {
  .textData > div {
    margin-top: 35px;
    font-size: 18px;
    line-height: 15px;
  }
  .textData .secondary {
    font-size: 15px;
  }
  .textData p {
    line-height: 20px;
  }
  .recruit {
    width: 90%;
  }
  .textData {
    width: 90%;
  }
}
@media (max-width: 578px) {
  .textData > div {
    margin-top: 35px;
    font-size: 16px;
    line-height: 15px;
  }
  .textData .secondary {
    font-size: 14px;
  }
  .textData p {
    font-size: 13px;
    line-height: 20px;
  }
  .recruit {
    width: 96%;
    box-shadow: none;
    border: 0px solid #fff;
  }
  .recruit p {
    font-size: 13px;
  }
  .textData {
    width: 96%;
    padding: 0 1em 1.8em;
    box-shadow: none;
    border: 0px solid #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/join.vue